
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/e06f7f177c6d4af8de02345d4366c7d7.jpg"
              alt="VELETRGOVINA TT DOO SABAC Team"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover object-top"
            />
          </div>
          <div>
            <h3 className="text-4xl font-bold text-gray-900 mb-6">
              About VELETRGOVINA TT DOO SABAC
            </h3>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Based in Sabac, Serbia, VELETRGOVINA TT DOO SABAC is a leading software development company dedicated to creating innovative applications that enhance digital security and user experience.
            </p>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Our flagship VPN application represents our commitment to protecting user privacy in an increasingly connected world. We combine cutting-edge technology with user-friendly design to deliver solutions that everyone can trust and use with confidence.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              At VELETRGOVINA TT, we believe that online privacy is a fundamental right. Our mission is to provide accessible, reliable, and powerful security tools that empower users to take control of their digital lives.
            </p>
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-blue-50 p-6 rounded-lg">
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-shield-star-line text-2xl text-white"></i>
                </div>
                <h5 className="font-bold text-gray-900 mb-2">Trusted Security</h5>
                <p className="text-gray-600 text-sm">Industry-leading protection standards</p>
              </div>
              <div className="bg-blue-50 p-6 rounded-lg">
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-user-heart-line text-2xl text-white"></i>
                </div>
                <h5 className="font-bold text-gray-900 mb-2">User-Focused</h5>
                <p className="text-gray-600 text-sm">Designed with you in mind</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
